import { api } from "../utils/apiClient";

class Payosu {
  paymentCallback(payload: any) {
    return api.post("unAuth/callback/payosuCallback", payload);
  }
}

export default new Payosu();
